import { setGAEvent } from '@/js/components/common'
import Modal from '@/js/components/modal'

const main = () => {
    if(!document.querySelector('#page-chef')) return false;
    const modal = new Modal();
    // 詳細のモーダル表示
    $('article.detail').prev('a.button').on('click', e => {
        let html = $(e.currentTarget).next('.detail').get(0).outerHTML
        modal.setHtml(html)
        modal.show()
        setGAEvent(modal.settings.createDom)
        return false
    })
}

export default main;